const API_URL = import.meta.env.VITE_API_URL;

export interface PasswordResetResponse {
  success: boolean;
  message: string;
  email: string;
  next_step?: string;
  expires_in_minutes?: number;
  action?: string;
  reset_token_valid?: boolean;
}

export interface PasswordResetError {
  error: string;
  action?: string;
  required_fields?: string[];
  hint?: string;
}

export const requestPasswordReset = async (email: string): Promise<PasswordResetResponse> => {
  const response = await fetch(`${API_URL}/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
    credentials: 'include'
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || data.detail || 'Failed to request password reset');
  }

  return data;
};

export const verifyResetOTP = async (email: string, otpCode: string): Promise<PasswordResetResponse> => {
  const response = await fetch(`${API_URL}/verify-reset-otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ 
      email, 
      otp_code: otpCode 
    }),
    credentials: 'include'
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || data.detail || 'Failed to verify OTP');
  }

  return data;
};

export const resetPassword = async (
  email: string, 
  otpCode: string, 
  newPassword: string, 
  confirmPassword: string
): Promise<PasswordResetResponse> => {
  const response = await fetch(`${API_URL}/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      otp_code: otpCode,
      new_password: newPassword,
      confirm_password: confirmPassword,
    }),
    credentials: 'include'
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || data.detail || 'Failed to reset password');
  }

  return data;
};